import JobWorkflowsPage from '@/pages/jobs/workflows'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function ProjectWorkflowsPage() {
  return (
    <WorkspacePortalProvider mode="project">
      <JobWorkflowsPage />
    </WorkspacePortalProvider>
  )
}
